import React, { useEffect } from 'react';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import { useQueryParam } from 'utils/use-query-param';

interface MainLayoutProps {
    children: JSX.Element | JSX.Element[];
}

const MainLayout = (props: MainLayoutProps): JSX.Element => {
    const aiauParam = JSON.parse(useQueryParam('aiau') || 'false');
    const archiPACParam = JSON.parse(useQueryParam('archiPAC') || 'false');

    useEffect(() => {
        if (aiauParam) {
            sessionStorage.setItem('isAiauPrechecked', aiauParam);
        }
        if (archiPACParam) {
            sessionStorage.setItem('isArchiPACPrechecked', archiPACParam);
        }
    }, [aiauParam, archiPACParam]);

    return (
        <div>
            <Header />
            {props.children}
            <Footer />
        </div>
    );
};

export default MainLayout;
